import { SvgIcon } from '@mui/material';

const Icon = (props: any) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <title>Chevron Forward</title>
    <polygon
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"
    />
  </SvgIcon>
);

export default Icon;
